module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Spoon-b1672a9a2aab43558c4ea638ad138e1d.svg";